var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBackward10Seconds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79 15.92v-3.39l-.19.21c-.28.31-.75.33-1.06.06a.756.756 0 0 1-.06-1.06l1.5-1.67c.21-.23.54-.31.83-.2.29.11.48.39.48.7v5.35c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75zM9.55 5.05A.757.757 0 0 1 9.43 4l1.98-2.47c.26-.32.73-.37 1.05-.12.32.25.37.73.12 1.05L10.6 4.93a.72.72 0 0 1-.58.29.7.7 0 0 1-.47-.17z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36 13.11c0-2.07.67-4.06 1.95-5.76a.75.75 0 0 1 1.2.9c-1.08 1.44-1.65 3.12-1.65 4.86 0 4.49 3.65 8.14 8.14 8.14s8.14-3.65 8.14-8.14S16.49 4.97 12 4.97c-.58 0-1.17.07-1.81.22-.4.09-.81-.16-.9-.56-.09-.4.16-.81.56-.9A9.7 9.7 0 0 1 12 3.47c5.31 0 9.64 4.32 9.64 9.64s-4.33 9.64-9.64 9.64c-5.31 0-9.64-4.32-9.64-9.64z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.92v-1.35c0-1.52 1.23-2.75 2.75-2.75s2.75 1.23 2.75 2.75v1.35c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75zm1.5-1.34v1.35a1.25 1.25 0 0 0 2.5 0v-1.35a1.25 1.25 0 0 0-2.5 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBackward10Seconds);
export default __webpack_public_path__ + "static/media/vuesax-outline-backward-10-seconds.8a09d3446326c189bf41db09809954fd.svg";
export { ForwardRef as ReactComponent };